import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'snack-bar',
  template: `<span class="snackbar-label bg-orange-800 text-white" matSnackBarLabel>{{ data }}</span>
    <span matSnackBarActions class="snackbar-actions bg-orange-800">
      <!-- No color="accent": the global .mat-accent label override (!important, higher
           specificity) would beat .text-orange-300 and render the dark accent color on
           this orange surface. Without it, .text-orange-300 wins for a readable light action. -->
      <button
        mat-button
        matSnackBarAction
        class="text-orange-300"
        (click)="snackBarRef.dismissWithAction()"
      >
        {{ actionLabel || 'Close' }}
      </button>
    </span> `,
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
        align-items: stretch;
        overflow: hidden;
        border-radius: 0.375rem;
      }

      .snackbar-label,
      .snackbar-actions {
        display: flex;
        align-items: center;
        min-height: 48px;
      }

      .snackbar-label {
        flex: 1 1 auto;
        padding: 0.75rem 1rem;
      }

      .snackbar-actions {
        flex: 0 0 auto;
        padding: 0 0.5rem 0 0;
      }
    `,
  ],
  standalone: true,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
})
export class SnackBarComponent {
  data = inject(MAT_SNACK_BAR_DATA);

  snackBarRef = inject(MatSnackBarRef);

  @Input() message!: string; // Input to receive the message
  @Input() actionLabel?: string; // Optional input for action button label
  @Input() actionClick?: () => void; // Optional input for action button click

  dismissWithAction(): void {
    if (this.actionClick) {
      this.actionClick(); // Execute the provided callback if available
    }
    this.snackBarRef.dismissWithAction();
  }
}
